import ExternalLink from './ExternalLink.jsx';

// The portal builds these from the group object id and validates them; the page checks the exact shape
// again, so anything else (another host, an extra segment, a query string) renders nothing.
const GUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
export const MY_GROUPS = new RegExp(`^https://myaccount\\.microsoft\\.com/groups/${GUID}$`);
export const ENTRA = new RegExp(`^https://entra\\.microsoft\\.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Members/groupId/${GUID}$`);

/** Two plain outbound links for a group event, so an owner or admin can check the live member list in Microsoft. */
export default function WatchGroupLinks({ links }) {
  const myGroups = typeof links?.myGroups === 'string' && MY_GROUPS.test(links.myGroups) ? links.myGroups : null;
  const entra = typeof links?.entra === 'string' && ENTRA.test(links.entra) ? links.entra : null;
  if (!myGroups && !entra) return null;
  return (
    <p className="flex flex-wrap gap-x-6 gap-y-1 text-sm">
      {myGroups ? <ExternalLink href={myGroups} className="font-medium text-ipc-light hover:underline">Open this group in Microsoft My Groups</ExternalLink> : null}
      {entra ? <ExternalLink href={entra} className="font-medium text-ipc-light hover:underline">Open in Entra admin center</ExternalLink> : null}
    </p>
  );
}
